import { InsightData } from 'schemas/action/InsightDataSchema'
import { SocialWebWordCloudWidget } from '../../../schemas/SocialWebWordCloudWidgetSchema'
import { AudienceWordCloudWidget } from '../../../schemas/AudienceWordCloudWidgetSchema'
import { SocialWebPhotoConceptsWidget } from '../../../schemas/SocialWebPhotoConceptsWidgetSchema'
import { SocialWebSentimentDriversWidget } from '../../../schemas/SocialWebSentimentDriversWidgetSchema'
import { AudienceSentimentDriversWidget } from '../../../schemas/AudienceSentimentDriversWidgetSchema'

export type WordCloudWidgetsType =
  | SocialWebWordCloudWidget
  | AudienceWordCloudWidget
  | SocialWebPhotoConceptsWidget
  | SocialWebSentimentDriversWidget
  | AudienceSentimentDriversWidget

export type InsightObjective = {
  insight: InsightData
  name: string
}

export type WordCloudSelectionType = {
  text: string
  custom: InsightData
}

export type TableSelectionType = {
  name: string
  value: number
  percentage: number
  key: string
  colorKey: string | undefined
  insight: any
}

export const isSentimentDriversWidget = (
  widgetSetting: WordCloudWidgetsType
): widgetSetting is SocialWebSentimentDriversWidget | AudienceSentimentDriversWidget =>
  !('color' in widgetSetting)
